// CustomerSection.js
// Customer section for the job dialog
 
 import React from 'react';
 import { isDriverOnly } from '../../utils/permissionStore'; // Updated import
 import { formatPhoneNumber } from '../../utils/phoneUtils';
 import {
   Grid,
  Paper,
  Typography,
  TextField
} from '@mui/material';
import FilterSelect from '../common/FilterSelect';

/**
 * Customer section component for the job dialog
 * @param {Object} props Component props
 * @param {Object} props.jobData Current job data
 * @param {Function} props.handleInputChange Function to handle input changes
 * @param {Array} props.userCompanies User's companies
 * @param {Object} props.currentUser Current user data
 * @returns {JSX.Element} Customer section component
 */
const CustomerSection = ({ jobData, handleInputChange, currentUser }) => {
  // console.log("CustomerSection.js - jobData.account:", jobData.account);
   
   // Check if user is driver-only
   // Use the imported isDriverOnly and pass necessary fields from currentUser prop
   const isDriverOnlyUser = currentUser ? isDriverOnly(currentUser.primaryRole, currentUser.secondaryRoles) : false;
   return (
     <Paper sx={{ p: 2, mb: 2 }}>
      <Typography variant="h6" gutterBottom>Customer</Typography>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={8}>
          <FilterSelect
            label="Payment Type"
            value={jobData.paymentType}
            options={['Credit Card', 'Cash', 'Invoice']}
            onChange={(value) => handleInputChange('paymentType', value)}
            disabled={isDriverOnlyUser}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            margin="dense"
            label="PO"
            fullWidth
            value={jobData.po}
            disabled
            helperText="Auto-generated on job creation"
            InputProps={{
              readOnly: true,
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="dense"
            label="Caller Name"
            fullWidth
            value={jobData.callerName}
            onChange={(e) => handleInputChange('callerName', e.target.value)}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="dense"
            label="Caller Phone"
            fullWidth
            value={formatPhoneNumber(jobData.callerPhone)}
            onChange={(e) => handleInputChange('callerPhone', formatPhoneNumber(e.target.value))}
            placeholder="(318) 555-0123"
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="dense"
            label="Customer Name *"
            fullWidth
            value={jobData.customerName}
            onChange={(e) => handleInputChange('customerName', e.target.value)}
            placeholder="First & Last Name"
            required
            error={!jobData.customerName}
            helperText={!jobData.customerName ? "Required" : ""}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            margin="dense"
            label="Customer Phone *"
            fullWidth
            value={formatPhoneNumber(jobData.customerPhone)}
            onChange={(e) => handleInputChange('customerPhone', formatPhoneNumber(e.target.value))}
            required
            placeholder="(318) 555-0123"
            error={!jobData.customerPhone}
            helperText={!jobData.customerPhone ? "Required" : ""}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            margin="dense"
            label="Customer Email"
            fullWidth
            value={jobData.customerEmail}
            onChange={(e) => handleInputChange('customerEmail', e.target.value)}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};

export default CustomerSection;
